<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text>
            <v-layout wrap>
                <v-flex xs12>
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.leadReference"
                        label="Reference"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.leadFirstName"
                        label="First name"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.leadLastName"
                        label="Last name"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.leadEmail"
                        label="Email"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.leadContact1"
                        label="Contact number"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                lead: {},
            }
        },

        props: ['itemInfo'],

        name: 'Lead-Info',

        mounted() {
            this.lead = this.itemInfo;
            setTimeout(() => {
                this.loading = false;
            }, 100);
        },

        methods: {
            createHVQuote() {
                let data = {
                    type: 'homevantage',
                    int_id: this.lead.intermediaryId,
                    lead_id: this.lead.leadId,
                    client_name: this.lead.leadFirstName.trim() + ' ' + this.lead.leadLastName.trim()
                };

                // if (typeof this.lead.policy !== 'undefined' && this.lead.policy !== null && typeof this.lead.policy.PolicyHolderID !== 'undefined') {
                //     data.holder_id = this.lead.policy.PolicyHolderID;
                // }

                this.createQuoteFromData(data);
            }
        }
    }
</script>
